import React, { useContext } from 'react';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Avatar from '@mui/material/Avatar';
import './SharedNote.css';
import TextField from '@mui/material/TextField';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import EmailSharp from '@mui/icons-material/EmailSharp'
import ArticleSharp from '@mui/icons-material/ArticleSharp'
import { styled } from '@mui/material/styles';
import Badge from '@mui/material/Badge';
import BbInbox from './BbInbox'
import { getContentByUserId } from './api'
import { contentSave } from './api'
import AuthContext from './AuthContext';
import { unReadCount } from './api'


function BbPad({ userId, notEditable }) {
  const { user } = useContext(AuthContext);
  const [noteContent, setNoteContent] = React.useState('');
  const [modified, setModified] = React.useState(false);
  const [debouncedContent, setDebouncedContent] = React.useState(noteContent); // 防抖后的内容

  // 模拟从服务端获取数据
  React.useEffect(() => {

    const fetchData = async () => {
      try {
        const result = await getContentByUserId({ userId })
        console.log({ user })
        setNoteContent(result.content)
      } catch {
        setNoteContent('加载出错');
      }

    };
    fetchData(); // 别忘了调用 `fetchData` 函数
  }, []);

  const handleTextFieldChange = (e) => {
    // 处理输入框变化的函数
    setNoteContent(e.target.value);
    setModified(true); // 标记内容已被修改
  };

  // 防抖机制：当 noteContent 变化时，设置 1 秒的延迟再更新 debouncedContent
  React.useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedContent(noteContent); // 在延迟结束后更新防抖后的内容
    }, 1000); // 设置 1 秒的延迟

    return () => {
      clearTimeout(handler); // 如果 noteContent 再次变化，清除之前的定时器
    };
  }, [noteContent]); // 依赖于 noteContent 变化

  // 当 debouncedContent 变化时，触发上传操作
  React.useEffect(() => {

    const saveContent = async () => {
      if (modified) {
        const content = {
          content: debouncedContent, // 使用防抖后的内容
          userId: userId,
        };
        try {
          await contentSave(content); // 使用 await 等待异步操作完成
          setModified(false); // 上传成功后，标记为未修改
        } catch {
          console.error('上传失败');
        }
      }
    };
    saveContent(); // 调用保存函数
  }, [debouncedContent]); // 

  return (
    <TextField
      multiline
      fullWidth
      rows={50}
      variant="standard"
      color="secondary"
      focused
      value={noteContent}
      onChange={handleTextFieldChange}
      placeholder="写下你的记事..."
      disabled={notEditable}
      sx={{
        padding: '15px',  // 为 TextField 增加一些内边距
        maxWidth: '100%',
        boxSizing: 'border-box',
      }}
    />
  );
}

function LabelBottomNavigation({ userId, notEditable, anotherUserId }) {
  const [value, setValue] = React.useState('Text');
  const [urc, setUrc] = React.useState(0);
  React.useEffect(() => {
    const ccF = async () => {
      try {
        const cc = await unReadCount({ userId });
        setUrc(cc);
      } catch {
        console.log("加载")
      }

    };
    ccF();
  }, []);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  React.useEffect(() => {

  }, [value])

  const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
      right: 0,
      top: 0,
      border: `2px solid ${theme.palette.background.paper}`,
      padding: '0 4px',
    },
  }));



  return (

    <Box>
      <Box sx={{ display: value === 'Text' ? 'block' : 'none', maxWidth: '100%', width: '100%', mb: 8, height: '100vh', overflow: 'hidden' }}>
        <BbPad userId={userId} notEditable={notEditable} />
      </Box>

      <Box sx={{ display: value === 'Inbox' ? 'block' : 'none', height: '100vh', maxWidth: '100%', width: '100%', mb: 8, overflow: 'hidden' }}>
        <BbInbox userId={userId} anotherUserId={anotherUserId} />
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'fixed', bottom: 0, width: '100%' }}>
        <BottomNavigation sx={{ width: 500 }} value={value} onChange={handleChange}>
          <BottomNavigationAction
            label="小黑板"
            value="Text"
            icon={<ArticleSharp />}
          />
          <BottomNavigationAction
            label="听居居念经"
            value="Inbox"
            icon={
              <StyledBadge badgeContent={urc} color="secondary" max={99}>
                <EmailSharp />
              </StyledBadge>}>
          </BottomNavigationAction>
        </BottomNavigation>
      </Box>　　　　　　　　　　　　　　　　　　　
    </Box >

  );
}

export default function SharedNote() {
  const [tabNum, setTabNum] = React.useState(1);
  const { user, loading, anotherUser } = useContext(AuthContext);
  const [avatarLoaded, setAvatarLoaded] = React.useState(false);
  const [anotherAvatarLoaded, setAnotherAvatarLoaded] = React.useState(false);
  const [allLoaded, setAllLoaded] = React.useState(false);

  // 处理头像图片加载
  React.useEffect(() => {
    if (user && anotherUser) {
      const userImg = new Image();
      const anotherUserImg = new Image();
      userImg.src = user.avatar;
      anotherUserImg.src = anotherUser.avatar;
      anotherUserImg.onload = () => setAnotherAvatarLoaded(true);
      anotherUserImg.onerror = () => setAnotherAvatarLoaded(true);
      userImg.onload = () => setAvatarLoaded(true);
      userImg.onerror = () => setAvatarLoaded(true);
    }
  }, [user, anotherUser]);


  React.useEffect(() => {
    // 当认证和头像都加载完成时，设置 loading 状态为 false
    if (!loading && avatarLoaded && anotherAvatarLoaded) {
      setAllLoaded(true);
    }
  }, [loading, avatarLoaded, anotherAvatarLoaded]);

  if (!allLoaded) {
    return <p>加载中...</p>; // 可以是一个加载指示器或简单的加载文本
  }

  const handleChange = (event, newTabNum) => {
    setTabNum(newTabNum); // 切换 Tab
  };

  return (
    <Box sx={{ width: '100%', bgcolor: 'background.paper' }}>
      <Tabs variant="fullWidth" value={tabNum} onChange={handleChange} centered>
        <Tab className='roll-in-blurred-left' icon={<Avatar alt="Remy Sharp" src="https://jiaoyangmajiang-1330964055.cos.ap-guangzhou.myqcloud.com/avatar_ma.png" />} label="麻酱酱" />
        <Tab className='roll-in-blurred-top' icon={<Avatar alt="Remy Sharp" src={user.avatar} />} label={user.name} />
        <Tab className='roll-in-blurred-right' icon={<Avatar alt="Remy Sharp" src={anotherUser.avatar} />} label={anotherUser.name} />
      </Tabs>

      <Box sx={{ display: tabNum === 0 ? 'block' : 'none' }}>
        <label> 麻酱酱的专属小黑板</label>
      </Box>

      {/* 使用 sx prop 替换 Hidden 组件 */}
      <Box sx={{ display: tabNum === 1 ? 'block' : 'none' }}>
        <LabelBottomNavigation userId={user.id} anotherUserId={anotherUser.id} notEditable={false} />
      </Box>

      <Box sx={{ display: tabNum === 2 ? 'block' : 'none' }}>
        <BbPad userId={anotherUser.id} notEditable={true} />
      </Box>
    </Box >
  );
}
